import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AssignmentIcon from "@material-ui/icons/Assignment";
import Build from "@material-ui/icons/Build";
import NotificationsIcon from "@material-ui/icons/Notifications";
import TimelineIcon from "@material-ui/icons/Timeline";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { checkRequiredPermissions, USER_GROUPS } from "../../../Utils/Common";
import { showSidebar } from "../../../redux/actions/sidebarActions";
import CollapseGroup from "../CollapseGroup";

/**
 * ContactsModule
 * DeviceModule
 * MaintenanceModule
 * SoftwareModule
 * SystemModule
 */
export default function MaintenanceModule() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  // Allowed Uswer groups
  return checkRequiredPermissions([USER_GROUPS.ADMIN]) ? (
    <CollapseGroup
      mainItemAction={() => {
        history.push("/cpanel/maintenance");
        dispatch(showSidebar(false));
      }}
      mainItemIcon={<Build />}
      header={t("maintenance.header")}
    >
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/maintenance/tickets");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <Build />
        </ListItemIcon>
        <ListItemText primary={t("maintenance.activeTickets")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/maintenance/ticketarchive");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary={t("maintenance.ticketArchive")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/maintenance/statistics");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <TimelineIcon />
        </ListItemIcon>
        <ListItemText primary={t("maintenance.statistics")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/alerts");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <NotificationsIcon />
        </ListItemIcon>
        <ListItemText primary={t("adminSideBar.alerts")} />
      </ListItem>
    </CollapseGroup>
  ) : null;
}
